import { guidePropertiesSelector } from '../selectors/properties';
import { guidePlayChannelAtIndexThunkAction } from './playChannelAtIndex';

export const guidePlaySelectedChannelThunkAction = () => (dispatch, getState) => {
  const state = getState();
  const { selectedIndex } = guidePropertiesSelector(state);
  return dispatch(guidePlayChannelAtIndexThunkAction({ index: selectedIndex }));
};
